import isAfter from 'date-fns/isAfter';
import formatDuration from 'date-fns/formatDuration';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';
import isSameYear from 'date-fns/isSameYear';

import addDays from 'date-fns/addDays';
import format from 'date-fns/format';

export type MaybeDate = Date | number | null | undefined;

export const now = () => new Date();

export const inFuture = (d: MaybeDate) => d && isAfter(d, now());

export const isToday = (d: MaybeDate) => d && isSameDay(d, now());

export const isYear = (d: MaybeDate) => d && isSameYear(d, now());

export const inPast = (d: MaybeDate) => d && isBefore(d, now());

export const isTomorrow = (d: MaybeDate) =>
  d && isSameDay(d, addDays(now(), 1));

/*export const isYesterday = (d: MaybeDate) =>
  d && isSameDay(d, addDays(now(), -1));*/

export const humanizeDate = (
  d: MaybeDate,
  opts?: { prefixAt?: boolean; preferLongFormat?: boolean },
) => {
  if (!d) return null;

  if (opts?.preferLongFormat) {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    return format(d, `ccc, LLLL d${isYear(d) ? '' : ' yyyy'}, hh:mm a`);
  }

  // If today, just show time. Otherwise, show date.
  // eslint-disable-next-line lingui/no-unlocalized-strings
  if (isToday(d)) return format(d, 'h:mm a');
  // eslint-disable-next-line lingui/no-unlocalized-strings
  else return format(d, `LLL d${isYear(d) ? '' : ', yyyy'}`);
};

export const humanizeDurationSecs = (seconds: number) => {
  if (seconds < 60) return Math.round(seconds) + 's';
  const minutes = seconds / 60;
  if (minutes < 60) return Math.round(minutes) + 'm';
  const hours = minutes / 60;
  if (hours < 60) return Math.round(hours) + 'h';
  const days = hours / 24;
  return Math.round(days) + 'd';
};

const pad = (n: number) => (n < 10 ? `0${n}` : n);


export const humanizeDurationSecsTime = (seconds: number) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = pad(seconds % 60);

  // pad with 0s

  return `${hrs > 0 ? `${hrs}:` : ''}${mins >= 0 ? `${mins}:` : ''}${secs}`;
};

export const hrToMS = (hr: number) => hr * 60 * 60 * 1000;

export const minToMS = (min: number) => min * 60 * 1000;
